import { APP_NAME } from "@constants/app.constants";
import PagesListComponent from "@screens/pages/pages-list/pages-list.component";
import PagesCreateComponent from "@screens/pages/pages-create/pages-create.component";
import PagesEditComponent from "@screens/pages/pages-edit/pages-edit.component";

const pagesRoutes = [
  {
    name: `Pages - ${APP_NAME}`,
    path: "/pages",
    icon: "layout",
    component: PagesListComponent,
  },
  {
    name: `Create Pages - ${APP_NAME}`,
    path: "/pages/create",
    component: PagesCreateComponent,
  },
  {
    name: `Edit Pages - ${APP_NAME}`,
    path: "/pages/edit",    
    component: PagesEditComponent,
  },
];

export default pagesRoutes;
